'use client'

import {
  CardData,
  PreviewCard,
  SectionWrapper,
  type SectionWrapperProps,
} from '@components/common'
import type { PreviewCardProps } from '@components/common/Cards/PreviewCard'
import { CustomStyles, getStyles, useCardStyles } from '@utils/styles'
import defaultStyles, { StyleClassNames } from './styles'

export type CardsSectionData = {
  cardsData?: CardData[]
  componentVariant?: PreviewCardProps['componentVariant']
}

export type CardsSectionProps = CardsSectionData & {
  csx?: CustomStyles<StyleClassNames>
  disablePadding?: boolean
  showDivider?: SectionWrapperProps['showDivider']
  noTopPadding?: boolean
}
export function CardsSection({
  cardsData,
  disablePadding,
  showDivider = 'bottom',
  noTopPadding = false,
  csx,
  componentVariant,
}: CardsSectionProps) {
  const styles = getStyles(defaultStyles, csx)

  const { cardStyles } = useCardStyles({
    count: cardsData?.length || 0,
  })

  if (!cardsData?.length) return null

  return (
    <SectionWrapper
      showDivider={showDivider}
      disablePadding={disablePadding}
      {...styles(
        'cardsWrapper',
        noTopPadding
          ? {
              paddingInline: '6.2% !important',
              paddingTop: {
                xs: '24px !important',
                md: 'unset',
              },
            }
          : {}
      )}
    >
      {cardsData.map((item, idx) => (
        <PreviewCard
          csx={{
            wrapper: cardStyles,
            image: styles('cardImage').sx,
            description: styles('previewCardDescription').sx,
          }}
          key={idx}
          {...item}
          componentVariant={componentVariant}
          actionButtonIconSx={{
            color: 'common.white',
          }}
        />
      ))}
    </SectionWrapper>
  )
}
